import React from "react";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import CartItem from "./CartItem";

/**
 * Componente para mostrar la lista de productos del carrito
 * @param {Array} productos - Lista de productos del carrito
 * @param {Array} productosSeleccionados - IDs de productos seleccionados
 * @param {Function} onCheckboxChange - Callback cuando cambia un checkbox individual
 * @param {Function} onSelectAll - Callback para seleccionar/deseleccionar todos
 * @param {Function} onQuantityChange - Callback cuando cambia la cantidad
 * @param {Function} onDelete - Callback para eliminar un producto
 * @param {Function} formatPrice - Función para formatear el precio
 */
const ProductList = ({
	productos,
	productosSeleccionados,
	onCheckboxChange,
	onSelectAll,
	onQuantityChange,
	onDelete,
	formatPrice,
	porcentajesDescuentoPorItem = {},
	montosDescuentoPorItem = {},
}) => {
	const todosSeleccionados =
		productos.length > 0 &&
		productosSeleccionados.length === productos.length;
	const algunosSeleccionados =
		productosSeleccionados.length > 0 &&
		productosSeleccionados.length < productos.length;

	return (
		<Card className="carrito-card">
			<CardBody className="carrito-card-body no-padding">
				<div className="carrito-card-title-section">
					<div className="carrito-select-all-container">
						<Checkbox
							checked={todosSeleccionados}
							indeterminate={algunosSeleccionados}
							onChange={onSelectAll}
							color="primary"
							className="carrito-checkbox-select-all"
						/>
						<h4 style={{ margin: 0 }}>Seleccionar todos</h4>
					</div>
					<Divider />
				</div>
				{productos.map((producto) => (
					<CartItem
						key={producto._id}
						producto={producto}
						isSelected={productosSeleccionados.includes(producto._id)}
						onCheckboxChange={() => onCheckboxChange(producto._id)}
						onQuantityChange={(incrementarOrCantidad) =>
							onQuantityChange(producto._id, incrementarOrCantidad)
						}
					onDelete={() => onDelete(producto._id)}
					formatPrice={formatPrice}
					porcentajeDescuento={porcentajesDescuentoPorItem[producto._id] || null}
					montoDescuento={montosDescuentoPorItem[producto._id] || null}
				/>
				))}
			</CardBody>
		</Card>
	);
};

export default ProductList;

